import seedrandom from 'seedrandom'

export type Rng = () => number

export function makeRng(tenantId: string): Rng {
  let seed: string
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search)
    const fromUrl = params.get('seed')
    if (fromUrl) {
      seed = fromUrl
    } else if (params.has('fresh')) {
      seed = String(Date.now())
    } else {
      seed = `ordermage-${tenantId}`
    }
  } else {
    seed = `ordermage-${tenantId}`
  }
  return seedrandom(seed)
}

export function intBetween(rng: Rng, min: number, max: number): number {
  return Math.floor(rng() * (max - min + 1)) + min
}

export function floatBetween(rng: Rng, min: number, max: number): number {
  return rng() * (max - min) + min
}

export function pick<T>(rng: Rng, arr: readonly T[]): T {
  return arr[Math.floor(rng() * arr.length)]
}

export function weighted<T>(rng: Rng, weights: Array<readonly [T, number]>): T {
  const total = weights.reduce((s, [, w]) => s + w, 0)
  let r = rng() * total
  for (const [v, w] of weights) {
    r -= w
    if (r <= 0) return v
  }
  return weights[weights.length - 1][0]
}
